import type { CityConfig } from "@/pages/city-template/types";

export const hutchinsonConfig: CityConfig = {
  vitalRecordsIcon: "ri-file-text-line",
  city: "Hutchinson",
  state: "Kansas",
  stateAbbr: "KS",
  slug: "hutchinson",
  route: "/hutchinson",
  title: "Emergency Passport Hutchinson, KS — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency passport and expedited passport services in Hutchinson, KS — as fast as 24 hours. Fast passport renewal, same-day help, and child passport expediting for Hutchinson and Reno County travelers. A+ BBB rated, registered State Dept. courier.",
  h1: "Emergency & Expedited Passport Services in Hutchinson, Kansas",
  heroSubtitle: "Mission trip to Mexico coming up and your passport expired? Family vacation out of ICT in weeks? Fast Passport Center helps Hutchinson travelers get their passports fast — as fast as 24 hours. A+ BBB rated. No office visit required for most services.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Hutchinson%20Kansas%20downtown%20streetscape%20with%20historic%20brick%20buildings%20and%20wide%20main%20street%2C%20Reno%20County%20courthouse%20architecture%2C%20Cosmosphere%20space%20museum%20exterior%2C%20Arkansas%20River%20landscape%20with%20prairie%20horizon%2C%20midwestern%20small%20city%20charm%20under%20bright%20blue%20sky%2C%20warm%20golden%20wheat%20tones%20and%20soft%20terracotta%20accents%2C%20photorealistic%20heartland%20cityscape&width=1800&height=700&seq=hutchinson-hero-01&orientation=landscape",
  heroImageAlt: "Hutchinson Kansas downtown streetscape with historic brick buildings and the Cosmosphere",
  geoPosition: "38.0608;-97.9295",
  geoPlacename: "Hutchinson, Kansas",
  lastModified: "2026-06-14",
  regionalAgency: {
    name: "Denver Passport Agency",
    address: "3151 S Vaughn Way, Suite 600, Aurora, CO 80014",
    distance: "Approximately 500 miles west — nearest regional passport agency for central Kansas travelers",
  },
  nearbyCitiesZips: [
    { name: "Hutchinson", zips: "67501–67504" },
    { name: "South Hutchinson", zips: "67505" },
    { name: "Buhler", zips: "67522" },
    { name: "Nickerson", zips: "67561" },
    { name: "Haven", zips: "67543" },
    { name: "McPherson", zips: "67460" },
    { name: "Newton", zips: "67114" },
    { name: "Wichita", zips: "67201–67260" },
    { name: "Salina", zips: "67401–67402" },
    { name: "Great Bend", zips: "67530" },
    { name: "Lyons", zips: "67554" },
  ],
  benefits: [
    { icon: "ri-computer-line", title: "Start 100% Online", desc: "No office visit required to begin. Complete your order from home or work in Hutchinson in minutes." },
    { icon: "ri-truck-line", title: "Ship Overnight from Reno County", desc: "FedEx and UPS locations in Hutchinson and nearby Wichita offer overnight shipping to our processing center." },
    { icon: "ri-shield-check-line", title: "Expert Document Review", desc: "Every application is reviewed by our team before submission to reduce errors and delays — especially important for last-minute passport needs." },
    { icon: "ri-calendar-check-line", title: "Reserved Agency Access", desc: "We hold reserved submission slots at the nearest regional passport center — no public appointment hunting needed." },
  ],
  testimonials: [
    {
      name: "James W.",
      location: "Hutchinson, KS",
      rating: 5,
      text: "Our church mission trip to Guatemala was coming up fast and I realized my passport had expired. Fast Passport Center came through — shipped from the FedEx on Main Street and had my passport in 4 days. Made the trip with time to spare. Thank you.",
      service: "Emergency Passport",
    },
    {
      name: "Linda P.",
      location: "Hutchinson, KS",
      rating: 5,
      text: "Needed passports for our family of five for a cruise out of Galveston. Fast Passport Center handled all the paperwork, including three child passports, and everything arrived in about a week. The process was so much easier than I expected.",
      service: "Family Passports",
    },
    {
      name: "Mike R.",
      location: "South Hutchinson, KS",
      rating: 5,
      text: "My renewal was super straightforward. Dropped my documents at the UPS Store in Hutchinson and had my new passport in 5 business days. The document review caught a minor issue that would have caused a rejection — that alone was worth it.",
      service: "Passport Renewal",
    },
  ],
  facilities: [
    {
      id: "hutchinson-main-post",
      name: "Hutchinson Post Office",
      type: "USPS Passport Acceptance",
      address: "128 E 1st Ave",
      city: "Hutchinson",
      state: "KS",
      zip: "67501",
      phone: "800-275-8777",
      hours: "Mon–Fri 9am–4:30pm",
      distance: "Downtown Hutchinson",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "Schedule Appointment",
      notes: "Primary passport acceptance location in Hutchinson. Appointment required — book online well in advance. Photo services available on-site.",
      icon: "ri-mail-line",
    },
    {
      id: "south-hutchinson-post",
      name: "South Hutchinson Post Office",
      type: "USPS Passport Acceptance",
      address: "201 N Main St",
      city: "South Hutchinson",
      state: "KS",
      zip: "67505",
      phone: "800-275-8777",
      hours: "Mon–Fri 9am–4pm",
      distance: "South Hutchinson — about 3 miles south",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "Schedule Appointment",
      notes: "Convenient option for South Hutchinson and southern Reno County residents.",
      icon: "ri-mail-line",
    },
    {
      id: "reno-county-clerk",
      name: "Reno County Clerk's Office",
      type: "County Passport Acceptance",
      address: "125 W 1st Ave",
      city: "Hutchinson",
      state: "KS",
      zip: "67501",
      phone: "620-694-2930",
      hours: "Mon–Fri 8am–5pm (by appointment)",
      distance: "Downtown Hutchinson",
      website: "https://www.renogov.org/",
      websiteLabel: "Reno County Government",
      notes: "Reno County clerk passport acceptance. Appointment recommended. May have shorter wait times than USPS locations.",
      icon: "ri-government-line",
    },
    {
      id: "mcpherson-post",
      name: "McPherson Post Office",
      type: "USPS Passport Acceptance",
      address: "115 E Euclid St",
      city: "McPherson",
      state: "KS",
      zip: "67460",
      phone: "800-275-8777",
      hours: "Mon–Fri 9am–4pm",
      distance: "McPherson — about 30 miles northeast",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "Schedule Appointment",
      notes: "Alternative option for northern Reno County and McPherson County residents.",
      icon: "ri-mail-line",
    },
    {
      id: "newton-post-hutch",
      name: "Newton Post Office",
      type: "USPS Passport Acceptance",
      address: "400 N Main St",
      city: "Newton",
      state: "KS",
      zip: "67114",
      phone: "800-275-8777",
      hours: "Mon–Fri 9am–4:30pm",
      distance: "Newton — about 35 miles east",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "Schedule Appointment",
      notes: "Alternative for eastern Reno County residents closer to the Harvey County line.",
      icon: "ri-mail-line",
    },
  ],
  faqs: [
    {
      q: "Can I get an emergency passport in Hutchinson before international travel?",
      a: "Yes. Through Fast Passport Center, Hutchinson travelers can get an expedited passport in as little as 2–9 business days, and emergency processing is available in as fast as 24 hours depending on your eligibility and travel documentation. Start your order online today.",
    },
    {
      q: "How fast can I renew my passport in Hutchinson?",
      a: "Fast passport renewal in Hutchinson is available through Fast Passport Center in as little as 3 business days with our expedited service. Renewal applications are eligible if your current passport was issued at age 16 or older and within the last 15 years. No office visit required for most renewals.",
    },
    {
      q: "Does Hutchinson have its own passport agency?",
      a: "Hutchinson, Kansas does not have a regional passport agency. The closest regional passport center is the Denver Passport Agency in Hot Springs, Arkansas (about 440 miles south). Fast Passport Center is the faster and more convenient solution for Hutchinson and Reno County residents — no 7-hour road trip required.",
    },
    {
      q: "What if my passport expires before my mission trip from ICT?",
      a: "If your passport expires before your flight from Wichita Dwight D. Eisenhower National Airport (ICT), don't wait. Most countries require at least 3–6 months of passport validity beyond your stay. Fast Passport Center can expedite your passport renewal so you don't miss your trip.",
    },
    {
      q: "Can I expedite a child passport in Hutchinson?",
      a: "Yes. Child passport expediting in Hutchinson is possible through Fast Passport Center, but child passports for minors 15 and under require an in-person acceptance step with parental consent. We provide a clear checklist and instructions so you know exactly what to expect.",
    },
    {
      q: "How long does a standard passport take in Hutchinson?",
      a: "If you apply through a standard post office acceptance facility in Hutchinson, processing times run 6–13 weeks — sometimes longer during peak travel season. If your travel is sooner than that, you need expedited processing. Fast Passport Center offers Hutchinson travelers processing as fast as 24 hours.",
    },
    {
      q: "What airports do Hutchinson passport holders typically fly from?",
      a: "Wichita Dwight D. Eisenhower National Airport (ICT) is the closest major airport for Hutchinson travelers, about 50 miles southeast with regional and some international connections. Kansas City International (MCI) is about 200 miles northeast for broader international routes. Fast Passport Center can help you meet your deadline regardless.",
    },
    {
      q: "Can I get a passport renewal near me in Hutchinson without visiting an office?",
      a: "Yes. Most Hutchinson adults who are renewing a passport can do so entirely by mail — no in-person visit required. Start your order online with Fast Passport Center, complete your documents at home, and ship them overnight from the FedEx or UPS location in Hutchinson.",
    },
  ],
  photoLocations: [
    { name: "Walgreens — Hutchinson", address: "1901 E 17th Ave, Hutchinson, KS 67501", hours: "Daily 8 AM – 10 PM", website: "https://www.walgreens.com/storelocator", websiteLabel: "Walgreens Photo" },
    { name: "Walmart — Hutchinson", address: "1905 E 17th Ave, Hutchinson, KS 67501", hours: "Daily 6 AM – 11 PM", website: "https://www.walmart.com/store/finder", websiteLabel: "Walmart Photo" },
    { name: "CVS — Hutchinson", address: "2500 N Main St, Hutchinson, KS 67502", hours: "Daily 7 AM – 10 PM", website: "https://www.cvs.com/store-locator/cvs-pharmacy-photo", websiteLabel: "CVS Photo" },
    { name: "FedEx Office — Wichita", address: "4620 E 13th St N, Wichita, KS 67208", hours: "Mon–Fri 7 AM – 10 PM, Sat 8 AM – 8 PM", website: "https://www.fedex.com/en-us/location.html", websiteLabel: "FedEx Office" },
    { name: "UPS Store — Hutchinson", address: "1429 N Main St, Hutchinson, KS 67501", hours: "Mon–Fri 8 AM – 6 PM, Sat 9 AM – 2 PM", website: "https://www.theupsstore.com/tools/find-a-store", websiteLabel: "UPS Store" },
  ],
  dmvLocations: [
    {
      name: "Hutchinson Driver License Office",
      address: "1700 E 23rd Ave, Hutchinson, KS 67502",
      hours: "Mon–Fri 7 AM – 5:45 PM",
      note: "Reno County DMV office. Driver licenses, REAL ID, ID cards. Walk-ins accepted but appointment recommended.",
      featured: true,
    },
    {
      name: "Wichita Driver License Office — East",
      address: "11150 E 21st St N, Wichita, KS 67206",
      hours: "Mon–Fri 7 AM – 5:45 PM",
      note: "Nearest large DMV in Wichita area for additional services.",
      featured: false,
    },
  ],
  airports: [
    {
      code: "ICT",
      name: "Wichita Dwight D. Eisenhower National Airport",
      distance: "Closest commercial airport — about 50 miles southeast",
      address: "2277 Eisenhower Airport Pkwy, Wichita, KS 67209",
      note: "ICT is the nearest airport for Hutchinson travelers. Regional and limited international connections available. Plan passport needs well in advance of travel from ICT.",
      flightUrl: "https://www.flywichita.com/",
      flightLabel: "ICT Airport Website",
      featured: true,
    },
    {
      code: "MCI",
      name: "Kansas City International Airport",
      distance: "Major international hub — about 200 miles northeast",
      address: "1 International Sq, Kansas City, MO 64153",
      note: "MCI offers broader international routes for Hutchinson travelers willing to make the drive.",
      flightUrl: "https://www.flykci.com/",
      flightLabel: "MCI Airport Website",
      featured: false,
    },
  ],
  services: [
    {
      icon: "ri-time-line",
      title: "Emergency Passport",
      description: "Flying from ICT or MCI in 24–72 hours? Our emergency courier service is designed for urgent, last-minute travel from Hutchinson and central Kansas.",
      bullets: ["As fast as 24 hours", "Reserved agency submission slots", "Live case tracking"],
      badge: "Same-Day Available",
      link: "https://fastpassportcenter.com/checkout/?passport=emergency-passport",
    },
    {
      icon: "ri-refresh-line",
      title: "Passport Renewal",
      description: "Already have a U.S. passport? We help Hutchinson and Reno County travelers renew fast — passport expired before trip is one of our most common urgent requests.",
      bullets: ["Eligible for expedited processing", "Ship from FedEx or UPS in Hutchinson", "Professional document review"],
      badge: "Most Common",
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-search-eye-line",
      title: "Lost Passport Replacement",
      description: "Lost your passport before a trip? We guide Hutchinson travelers through Form DS-64 and the replacement process — urgent timelines available.",
      bullets: ["DS-64 form guidance included", "Replacement processing", "Urgent timelines available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Child passport expedited service for Hutchinson families — minors under 16 require in-person acceptance and parental consent. We provide clear instructions and checklists.",
      bullets: ["Both parents must typically consent", "Clear checklist provided", "Expedited options after acceptance step"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-add-line",
      title: "New Passport",
      description: "First-time passport application assistance for Hutchinson residents — we guide you through the acceptance clerk process and handle expedited processing.",
      bullets: ["Step-by-step checklist", "Acceptance clerk guidance", "Expedited after clerk visit"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-truck-line",
      title: "Passport Courier Service",
      description: "Fast Passport Center is a registered U.S. Department of State courier — we submit through reserved agency channels, not public lines.",
      bullets: ["State Dept. registered courier", "Reserved daily submission slots", "Not affected by government shutdowns"],
      badge: "Registered Courier",
      link: "https://fastpassportcenter.com/checkout/",
    },
    {
      icon: "ri-edit-line",
      title: "Name Change & Other Services",
      description: "Passport name changes after marriage or divorce, damaged passport replacement, second passports for frequent travelers — all handled with the same expedited courier access.",
      bullets: ["Name change after marriage/divorce", "Damaged passport replacement", "Second passport for frequent travel"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport", description: "Urgent passport processing for Hutchinson, Kansas travelers with immediate departure needs, as fast as 24 hours." },
    { name: "Expedited Passport", description: "Expedited passport processing for Hutchinson residents needing passports faster than standard government mail timelines." },
    { name: "Passport Renewal", description: "Fast passport renewal for Hutchinson, KS residents with a passport issued within the last 15 years at age 16 or older." },
    { name: "Lost Passport Replacement", description: "Emergency passport replacement service for Hutchinson travelers with lost or stolen passports." },
    { name: "Child Passport", description: "Expedited child passport services for Hutchinson families with minors under 16." },
  ],
  mistakes: [
    { icon: "ri-time-line", title: "Waiting Too Long to Apply", description: "Hutchinson travelers often assume 6–8 weeks is safe — it's not. Government processing has stretched to 10–14+ weeks during peak travel season. Apply as soon as you book your trip." },
    { icon: "ri-camera-off-line", title: "Wrong Passport Photo", description: "Photos from drugstores and photo booths often get rejected for lighting, background, or expression issues. We provide exact specs and can catch these issues before documents are submitted." },
    { icon: "ri-file-damage-line", title: "Incomplete or Incorrect Forms", description: "One wrong date, one missing signature — your application gets sent back and you lose weeks. Our checklist catches errors before submission." },
    { icon: "ri-calendar-close-line", title: "Assuming the Post Office is Fast Enough", description: "Standard USPS passport processing out of Hutchinson runs 6–13 weeks. If your trip is in under 10 weeks, standard processing is a gamble. Use our courier service instead." },
    { icon: "ri-map-pin-time-line", title: "Name Mismatch Across Documents", description: "Your passport name must match your airline ticket exactly. Middle names, hyphens, and suffixes cause more rejections than you'd expect." },
  ],
  steps: [
    { number: "01", icon: "ri-computer-line", title: "Start Your Order Online", description: "Choose your processing speed based on your Hutchinson travel date. Complete your secure order online — takes just a few minutes." },
    { number: "02", icon: "ri-file-list-3-line", title: "Receive Your Personalized Checklist", description: "We confirm your details and send you a personalized document checklist — exactly what you need, nothing more." },
    { number: "03", icon: "ri-send-plane-line", title: "Ship Documents Overnight from Hutchinson", description: "Drop off at the FedEx on Main Street or the UPS Store in Hutchinson — both offer overnight shipping." },
    { number: "04", icon: "ri-building-2-line", title: "We Submit Through Reserved Access", description: "We submit your application through our reserved passport agency slots — bypassing the public appointment system entirely." },
    { number: "05", icon: "ri-passport-line", title: "Your Passport is Completed", description: "Your passport is completed within the timeframe you selected and shipped back to you." },
  ],
  processingOptions: [
    {
      speed: "2–9", unit: "Business Days", label: "Fast Passport Center",
      tag: "Most Popular", tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Reserved agency submission", "Predictable turnaround", "Document review included", "Dedicated agent assigned", "Not affected by government shutdowns"],
      highlight: true,
    },
    {
      speed: "3–5", unit: "Weeks", label: "Fast Passport Center",
      tag: "Standard Expedited", tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Reserved agency submission", "Faster than self-service", "Document review included"],
      highlight: false, smartSaver: true,
    },
    {
      speed: "1–2", unit: "Months", label: "Self-Service (Post Office)",
      tag: "Slowest", tagColor: "bg-gray-100 text-gray-400",
      features: ["No courier access", "In-person clerk appointment required", "No document review", "No dedicated agent", "Not suitable if travel is within 10 weeks"],
      highlight: false, muted: true,
    },
    {
      speed: "24", unit: "Hours*", label: "Regional Agency Processing",
      tag: "Emergency Only", tagColor: "bg-gray-100 text-gray-500",
      features: ["Appointment required", "Life-or-death emergencies only", "Expect to wait all day or return next day"],
      highlight: false, emergency: true,
    },
  ],
  comparisonRows: [
    { feature: "Appointment Required", agency: "Yes — limited slots at Denver Passport Agency", fpc: "No appointment needed to start" },
    { feature: "In-Person Visit", agency: "Must drive to Hot Springs, AR (7 hours)", fpc: "Ship documents overnight from Hutchinson" },
    { feature: "Processing Speed", agency: "Urgent travel only — strict eligibility", fpc: "As fast as 24 hours — multiple speed options" },
    { feature: "Document Review", agency: "None — errors cause rejection", fpc: "Professional review included" },
    { feature: "Courier Access", agency: "Not available to the public", fpc: "Reserved daily submission slots" },
    { feature: "Government Shutdowns", agency: "Operations may be impacted", fpc: "Not affected by government shutdowns" },
    { feature: "Turnaround Predictability", agency: "Depends on appointment availability — no guarantee", fpc: "Guaranteed processing within selected timeframe" },
    { feature: "Customer Support", agency: "Government clerk — limited availability", fpc: "Dedicated agent assigned to your case with daily updates" },
    { feature: "Travel Required", agency: "Yes — must travel to Denver in person", fpc: "No — ship documents from home or office in Hutchinson" },
  ],
  stickyNavLinks: [
    { label: "Processing Options", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Acceptance Locations", href: "#acceptance-facilities" },
    { label: "vs. Regional Agency", href: "#comparison" },
    { label: "FAQ", href: "#faq" },
    { label: "Local Resources", href: "#local-resources" },
  ],
  internalLinks: [
    { name: "Expedited passport services in Wichita", route: "/wichita" },
    { name: "Fast passport renewal in Salina", route: "/salina" },
    { name: "Emergency passport help in McPherson area", route: "/kansas" },
    { name: "Rush passport service for Reno County", route: "/kansas" },
    { name: "Fast passport renewal across Kansas", route: "/kansas" },
  ],
  fpcOfficeNote: "After signing up online, we send your personalized checklist and shipping instructions. Ship your documents overnight from the FedEx or UPS Store in Hutchinson — both are conveniently located. No office visit to our facility required for most services.",
  fpcOfficeDistance: "Serving Hutchinson and all of Reno County remotely",
  serviceAreaIntro: "Whether you are in Hutchinson, South Hutchinson, Buhler, Nickerson, Haven, or anywhere in Reno County, Fast Passport Center makes expedited passport processing simple — start online, ship overnight, and we handle the rest.",
  nearbyCitiesIntro: "We serve all Hutchinson and Reno County zip codes. From central Kansas — ship overnight and your documents are at our processing center the next morning.",
  howItWorksIntro: "From start to finish, we make getting an expedited passport in Hutchinson as simple as possible. Most Hutchinson clients never visit an office.",
  mistakesIntro: "These mistakes cause the most delays and rejections for Hutchinson travelers. Fast Passport Center reviews your documents before submission to catch these issues.",
  testimonialsIntro: "Real reviews from Hutchinson and Reno County travelers who needed their passports fast and trusted Fast Passport Center.",
  faqIntro: "The most common questions Hutchinson and Reno County travelers ask about emergency and expedited passport services.",
  statePageRoute: "/states/kansas",
  statePageName: "Kansas",
};